import React from 'react';

export const RightArrow = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.31311 13.6875C5.11785 13.4923 5.11785 13.1757 5.31311 12.9804L10.2929 8.00065L5.31311 3.02087C5.11785 2.82561 5.11785 2.50903 5.31311 2.31376C5.50838 2.1185 5.82496 2.1185 6.02022 2.31376L11.3536 7.6471C11.5488 7.84236 11.5488 8.15894 11.3536 8.3542L6.02022 13.6875C5.82496 13.8828 5.50838 13.8828 5.31311 13.6875Z"
        fill="#2A3B4C"
      />
    </svg>
  );
};
